NotificationHelper = LP.module 'NotificationHelper'
NotificationHelper.site = ->
  EntityHighlightRunner.init()

NotificationHelper.message = (content, options) ->
  options ||= type: 'info'
  @container ||= new MessagesDisplay('notifications-helper')
  @container.clear() unless options.append
  @container.add_messages(content, options.type)
  @container.open()

  if options.autohide
    clearTimeout @timeoutid
    @timeoutid = setTimeout $.proxy(@container.close, @container), options.autohide
  this

NotificationHelper.error = (content, options) ->
  options ||= {}
  options.type = 'danger'
  @message content, options

NotificationHelper.success = (content, options) ->
  options ||= {}
  options.type = 'success'
  @message content, options

NotificationHelper.warn = (content, options) ->
  options ||= {}
  options.type = 'warning'
  @message content, options

NotificationHelper.close = ->
  @container.close()

NotificationHelper.clear = ->
  @container.clear()


MessagesDisplay = (id)->
  @element = $("<div class='messages-container'></div>")
  @element.attr('id', id) if id?
  @element.append $('<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>').on('click', $.proxy(@close, this))
  @element.appendTo document.body
  this

MessagesDisplay.prototype.close = ->
  @element.hide('fast')

MessagesDisplay.prototype.clear = ->
  @element.find('.alert').remove()

MessagesDisplay.prototype.open = ->
  @element.show('fast')

MessagesDisplay.prototype.add_messages = (messages, type) ->
  $div = if messages instanceof $
           messages
         else
           $("<div class='alert alert-#{type} alert-dismissable'></div>").html(messages)

  @element.append($div)
  this

EntityHighlightRunner =
  init: ->
    $('.highlight').each ->
      $this = $ this
      $this.popover().popover('show')
      setTimeout(->
        $this.popover('hide')
      , 3000)
